import * as React from 'react';

export default (
  resizeCallback: ResizeObserverCallback,
  reference: React.RefObject<HTMLElement>,
): void => {
  const resizeObserver = new ResizeObserver(resizeCallback);
  React.useEffect(() => {
    if (reference.current) {
      resizeObserver.observe(reference.current);
    }
    return () => {
      if (reference.current) {
        resizeObserver.disconnect();
      }
    };
  }, []);
};
